"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var createIcon_1 = __importDefault(require("../createIcon"));
var BrandIconEmail = function (props) {
    return (react_1.default.createElement(createIcon_1.default, __assign({ role: "img", ariaLabel: "Email" }, props),
        react_1.default.createElement("title", null, "Email"),
        react_1.default.createElement("path", { d: "M60 25.714H8.571v68.572H60V25.714z", fill: "#FF6E00" }),
        react_1.default.createElement("path", { d: "M111.429 25.714H60v68.572h51.429V25.714z", fill: "#D44513" }),
        react_1.default.createElement("path", { d: "M8.571 25.714L60 71.432V25.714H8.571z", fill: "#007562" }),
        react_1.default.createElement("path", { d: "M111.429 25.714L60 71.432V25.714h51.429z", fill: "#000" })));
};
exports.default = BrandIconEmail;
